import { render } from "./SubHeader.vue?vue&type=template&id=1cc6064b&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=1cc6064b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc6064b"]])

export default __exports__